/**
 * Integrations we are still validating with early customers (REV-22557). Customers can already
 * use them; their card shows a "BETA" badge that explains this on hover.
 *
 * Keyed by the card's `vendor` id as a plain string, not by `IntegrationVendor`: the list can
 * name a vendor before (or without) its enum entry, and it covers non-vendor cards the same way.
 * Once an integration is validated, remove its id here — nothing else changes.
 */
export const BETA_INTEGRATIONS: ReadonlySet<string> = new Set(['PROFFIX', 'ACCOUNTO']);

export function isBetaIntegration(vendor: string | null | undefined): boolean {
    return vendor != null && BETA_INTEGRATIONS.has(vendor);
}
